import Num from '@flipster/utils/num';

/** 백엔드 ROI는 ratio("0.0123") — 표시는 percent(1.23). % suffix가 필요한 곳은 Formatted.Percent isRate를 쓸 것 */
export function toRoiPercent(value: string): string;
export function toRoiPercent(value: string | undefined): string | undefined;
export function toRoiPercent(value: string | undefined): string | undefined {
  return value == null ? undefined : Num(value).times(100).toString();
}
